import React, {useCallback, useEffect, useState} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow, Paper,
} from '@mui/material';
import api from "../../../services/api";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from '@mui/material/styles';
import {DialogProps} from "@mui/material/Dialog";

interface ConfirmDialogProps {
  open: boolean;
  data: any;
  onClose: () => void;
  onConfirm: () => void;
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const PendingRowUpdateDialog: React.FC<ConfirmDialogProps> = ({
                                                       open,
                                                       data,
                                                       onClose,
                                                       onConfirm
                                                     }) => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<DialogProps['maxWidth']>('md');

  const fetchData = useCallback(() => {
    
    setLoading(true);
    const searchParams = new URLSearchParams({
      exclude_cancelled: 'true',
    });

    api.get(`/activity-reservations/${data?.activity_reservation?.id?data?.activity_reservation?.id:data?.id}/service-reservations`, searchParams).then((result:any) => {
      setRows(result);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          All the connected Reservations' statuses will be modified.
        </Typography>

        <Box sx={{
          marginTop: '20px'
        }}>
          <TableContainer component={Paper}>
            <Table
              size="small"
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{
                    width: '50px'
                  }}>#</TableCell>
                  <TableCell
                    sx={{
                      width: '150px'
                    }}
                  >Service Provider</TableCell>
                  <TableCell
                    sx={{
                      width: '150px'
                    }}
                  >Service</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {loading ? (
                  <TableRow>
                    <TableCell
                      colSpan={3}
                      align={"center"}
                    >
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                  rows.map((row, index) => (
                    <StyledTableRow
                      key={row.name}
                      sx={{
                        '&:last-child td, &:last-child th': {
                          border: 0
                        }
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {index+1}
                      </TableCell>
                      <TableCell>{row?.service?.service_provider?.name}</TableCell>
                      <TableCell>{row?.service?.name}</TableCell>
                    </StyledTableRow>
                  ))
                )}

              </TableBody>
            </Table>
          </TableContainer>
        </Box>

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="error" onClick={onConfirm} autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PendingRowUpdateDialog;
